import React, { useState } from 'react';

const styles = {
  page: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#f7f7f7',
    boxSizing: 'border-box',
  },
  header: {
    padding: '20px 24px 16px',
    backgroundColor: '#fff',
    borderBottom: '1px solid #e8e8e8',
    boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
  },
  title: {
    margin: '0 0 14px',
    fontSize: '15px',
    fontWeight: '600',
    color: '#1f1d1e',
    letterSpacing: '0.02em',
  },
  form: {
    display: 'flex',
    gap: '10px',
    maxWidth: '720px',
  },
  input: {
    flex: 1,
    padding: '9px 14px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    outline: 'none',
    color: '#1f1d1e',
    backgroundColor: '#fafafa',
    transition: 'border-color 0.2s',
  },
  button: {
    padding: '9px 22px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#fff',
    backgroundColor: 'var(--cobalt)',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  iframeWrap: {
    flex: 1,
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    display: 'block',
  },
  empty: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#999',
    fontSize: '14px',
  },
};

const IframeTest = () => {
  const [url, setUrl] = useState('');
  const [submittedUrl, setSubmittedUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmittedUrl(url);
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <p style={styles.title}>Iframe Test</p>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Enter URL and press Load"
            style={styles.input}
          />
          <button type="submit" style={styles.button}>
            Load
          </button>
        </form>
      </div>
      {submittedUrl ? (
        <div style={styles.iframeWrap}>
          <iframe
            src={submittedUrl}
            title="Virtual Mirror"
            style={styles.iframe}
          />
        </div>
      ) : (
        <div style={styles.empty}>Enter a URL above to preview</div>
      )}
    </div>
  );
};

export default IframeTest;
